export const TYPE_SUPPLIER = 1;
export const TYPE_CLIENT = 2;
export const TYPE_ELEVATOR = 3;



// WEBPACK FOOTER //
// ./constants/clientTypes.js